import MixerItem from "./MixerItem";
import { useTranslation } from "react-i18next";

const MixerSection = ({ title, clearable, list, onRemove, onClearAll }) => {
    const { t } = useTranslation();
    
    // Map category names to translation keys
    const getTranslatedTitle = (titleText) => {
        const titleMap = {
            "sounds & music": t("player.soundsAndMusic"),
            "relaxation": t("player.relaxation"),
            "articles": t("player.articles"),
            "stories": t("player.stories"),
            "AV Articles": t("nav.avArticles")
        };
        return titleMap[titleText?.toLowerCase()] || titleMap[titleText] || titleText;
    };
    
    return (
        <div className="sounds-wrapper flex-shrink-0">
            <div className="audioHeader px-3 pb-2 d-flex justify-content-between">
                <p style={{ fontSize: 13, lineHeight: "1.2" }}>{getTranslatedTitle(title)}</p>
                {clearable && <button className="clearMixButton text-nowrap" onClick={onClearAll}>{t("player.clearAll")}</button>}
            </div>
            <div className="individualSoundsWrapper pb-2">
                {list.map((item, index) => <MixerItem key={index} data={item} onRemove={onRemove} />)}
            </div>
        </div>
    );
};

export default MixerSection;